import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { loadSubscriptionsExpiringSoonDailyAsync, selectSubscriptionsExpiringSoonDaily } from '../dashboardSlice';
import { StatCard } from './StatCard';

const HISTORY_DAYS = 14;
const DAYS_AHEAD = 7;

export const SubscriptionsExpiringCard = () => {
    const dispatch = useDispatch();
    const routerHistory = useHistory();
    const { data, status } = useSelector(selectSubscriptionsExpiringSoonDaily);

    useEffect(() => {
        dispatch(loadSubscriptionsExpiringSoonDailyAsync({ days: HISTORY_DAYS, aheadDays: DAYS_AHEAD }));
    }, [dispatch]);

    const { today, history } = useMemo(() => {
        if (!Array.isArray(data) || !data.length) return { today: 0, history: [] };
        return {
            today: data[data.length - 1]?.count ?? 0,
            history: data.map(d => d.count),
        };
    }, [data]);

    return (
        <StatCard
            label="Assinaturas vencendo"
            secondary={`Próximos ${DAYS_AHEAD} dias`}
            icon="pi-calendar-times"
            color="var(--pink-500)"
            value={today}
            loading={status === 'idle'}
            history={history}
            onClick={() => routerHistory.push('/users', { preset: 'expiringSoon', presetLabel: `Assinaturas vencendo (próx. ${DAYS_AHEAD} dias)` })}
        />
    );
};
